'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = require('react-i18next');

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./CheckedCount.scss');

var CheckedCount = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(CheckedCount, _PureComponent);

  function CheckedCount() {
    (0, _classCallCheck3.default)(this, CheckedCount);
    return (0, _possibleConstructorReturn3.default)(this, (CheckedCount.__proto__ || (0, _getPrototypeOf2.default)(CheckedCount)).apply(this, arguments));
  }

  (0, _createClass3.default)(CheckedCount, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          checkedCount = _props.checkedCount,
          t = _props.t,
          buttonClass = _props.buttonClass,
          onClear = _props.onClear,
          title = _props.title;

      var displayedTitle = title || t('Clear selection');

      if (!checkedCount) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: className },
        t('Checked'),
        ': ',
        checkedCount,
        _react2.default.createElement('i', {
          className: (0, _bind2.default)(buttonClass, styles.clearIcon),
          onClick: onClear,
          title: displayedTitle
        })
      );
    }
  }]);
  return CheckedCount;
}(_react.PureComponent), _class2.propTypes = {
  buttonClass: _propTypes2.default.string,
  checkedCount: _propTypes2.default.number,
  className: _propTypes2.default.string,
  onClear: _propTypes2.default.func,
  t: _propTypes2.default.func,
  title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node])
}, _class2.defaultProps = {
  onClear: _noop3.default
}, _temp)) || _class);
exports.default = CheckedCount;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CheckedCount/CheckedCount.js
// module id = 818
// module chunks = 1